<template>
  <div>
    <div
      class="magazines"
      :class="{ borderTop, borderBottom }"
      v-for="item in items"
      :key="item.id"
    >
      <MagazineCard
        wide
        :path="item.path"
        :title="item.title"
        :image="item.image"
        :imageAlt="item.imageAlt"
        :date="item.date"
        :url="item.url"
        :category="item.category"
        :description="item.description"
        :membershipOnly="item.membershipOnly"
        :parentCategorySlug="item.parentCategorySlug"
        :articleIndex="articleIndex"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import { MagazineCardProps } from '@/types/MagazineSpecial'
export default defineComponent({
  name: 'MagazineCardList',
  props: {
    items: {
      type: Array as PropType<MagazineCardProps[]>,
      default: () => []
    },
    borderTop: Boolean,
    borderBottom: Boolean,
    articleIndex: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MagazineCard
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.magazines {
  padding: 20px 0;
  &:not(:first-child) {
    border-top: 1px solid var.$color-border-gray;
  }
}
.borderTop {
  &:first-child {
    border-top: 1px solid var.$color-border-gray;
  }
}
.borderBottom {
  &:last-child {
    border-bottom: 1px solid var.$color-border-gray;
  }
}
</style>
